import { CLIENT_CONFIG, CLIENT_ID, THEME, BRANDING } from '../../client-config'

export const useClientConfig = () => {
    const isWisesheets = CLIENT_ID === 'default'
    return {
        clientConfig: CLIENT_CONFIG,
        clientId: CLIENT_ID,
        theme: THEME,
        branding: BRANDING,
        isWisesheets,
        companyName: BRANDING.companyName,
    }
}
